import React from 'react'
 
export const BaseHeroSection = ()=>{


    return (
        <section id="heroSection">
        <div className="hero-content">
            <h1>Get Millions of downloads!</h1>
            <p>Delectus corrupti asperiores, voluptas
                voluptatem alias maiores dolorum veritatis atque, officiis explicabo a quae error autem exercitationem
                aperiam iure quod quo sapiente.</p>
            <div className="btn btn-green">GET IN TOUCH</div>

        </div>
        <img src="/assets/images/bg/bg.jpg" draggable="false" alt=""/>
    </section>
    )
}

